import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { finalize, Subscription, timer } from 'rxjs';
import { UsersService } from 'src/app/services/users.service';

@Component({
  selector: 'app-users-request-password-reset',
  templateUrl: './users-request-password-reset.component.html'
})
export class UsersRequestPasswordResetComponent implements OnInit, OnDestroy {
  email = new FormControl('', [Validators.required, Validators.email]);
  sending = false;
  sent = false;
  error = '';
  remainingSeconds = 0;
  private countdown?: Subscription;

  constructor(
    private users: UsersService,
    private dialog: MatDialogRef<UsersRequestPasswordResetComponent>
  ) {}

  ngOnInit(): void {
    this.refreshCountdown();
    this.countdown = timer(0, 1000).subscribe(() => this.refreshCountdown());
  }

  ngOnDestroy(): void {
    this.countdown?.unsubscribe();
  }

  get countdownDisplay(): string {
    return `${Math.floor(this.remainingSeconds / 60)}:${String(this.remainingSeconds % 60).padStart(2, '0')}`;
  }

  private refreshCountdown(): void {
    this.remainingSeconds = this.users.passwordResetWaitSeconds;
  }

  submit(): void {
    this.email.setValue((this.email.value || '').trim());
    this.email.markAsTouched();
    this.refreshCountdown();
    if (this.email.invalid || this.sending || this.remainingSeconds > 0) { return; }

    this.error = '';
    this.sent = false;
    this.sending = true;
    this.dialog.disableClose = true;
    this.users.requestPasswordReset(this.email.value).pipe(
      finalize(() => {
        this.sending = false;
        this.dialog.disableClose = false;
        this.refreshCountdown();
      })
    ).subscribe({
      next: response => {
        this.sent = response.message === 'Success';
        if (!this.sent) { this.error = 'No fue posible solicitar el enlace. Intente nuevamente al terminar la espera.'; }
      },
      error: err => {
        this.error = err.status === 429
          ? 'Debe esperar 5 minutos entre solicitudes. Intente nuevamente al terminar la espera.'
          : err.status === 403
            ? 'El correo no es válido. Revíselo antes de volver a intentarlo.'
            : 'No fue posible solicitar el enlace. Intente nuevamente al terminar la espera.';
      }
    });
    this.refreshCountdown();
  }
}
